import { createSelector } from 'reselect';

import VehicleGpsTrackingApi from './api';

export const getBillingPlanFeatures = createSelector(
  (state) => state.vehicle_gps_tracking,
  (data) => (data ? data.features : [])
);

export const fetchBillingPlanFeatures = {
  fetchingApiFunc: VehicleGpsTrackingApi.show,
  selector: getBillingPlanFeatures,
  dataNamespace: 'vehicle_gps_tracking',
};

export const getMojioDevices = createSelector(
  (state) => state.vehicle_gps_tracking,
  (data) => (data ? data.devices : [])
);

export const fetchVehicleGpsDevices = {
  fetchingApiFunc: VehicleGpsTrackingApi.devices,
  selector: getMojioDevices,
  dataNamespace: 'vehicle_gps_tracking',
};
